import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AceitesService } from 'src/app/pages/privado/services/saude/aceites.service';
@Component({
  selector: 'app-modal-alert-validacao-cadastral',
  templateUrl: './modal-alert-validacao-cadastral.component.html',
  styleUrls: ['./modal-alert-validacao-cadastral.component.css']
})
export class ModalAlertValidacaoCadastralComponent {
  @Input() recadastramento!: any;
  variavil: any = 1;
  constructor(public activeModal: NgbActiveModal, private router: Router, private aceitesService: AceitesService) { }
  confirm() {
    this.activeModal.close(true);
    this.aceitesService.PostRecadastramento().subscribe({
      next: (res: any) => {
      },
      error: (err: any) => {
      }
    });
  }
  go() {
    this.activeModal.close(true);
    this.router.navigate(["/dados-cadastrais"], { queryParams: { valueTeste: 1 } });
  }
}
